(function () {
  function resetCard(card) {
    var video = card.querySelector('.bvt-video');
    var btn = card.querySelector('.bvt-play-btn');
    if (video && !video.paused) video.pause();
    card.classList.remove('bvt-playing');
    if (btn) {
      var play = btn.querySelector('.bvt-icon-play');
      var pause = btn.querySelector('.bvt-icon-pause');
      if (play) play.style.display = '';
      if (pause) pause.style.display = 'none';
    }
  }

  function pauseAll(scope) {
    scope.querySelectorAll('.bvt-card').forEach(resetCard);
  }

  function initSection(sectionEl) {
    var swiperEl = sectionEl.querySelector('.bvt-swiper');
    if (!swiperEl) return;

    var prevBtn = sectionEl.querySelector('.bvt-prev');
    var nextBtn = sectionEl.querySelector('.bvt-next');

    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1.2,
      spaceBetween: 10,
      navigation: { prevEl: prevBtn, nextEl: nextBtn },
      breakpoints: {
        480:  { slidesPerView: 1.2, spaceBetween: 10 },
        640:  { slidesPerView: 1.5, spaceBetween: 15 },
        769:  { slidesPerView: 2.2, spaceBetween: 15 },
        1024: { slidesPerView: 3,   spaceBetween: 20 },
        1280: { slidesPerView: 4,   spaceBetween: 20 }
      },
      on: {
        slideChange: function () { pauseAll(sectionEl); }
      }
    });
  }

  function initPlayButtons() {
    document.querySelectorAll('.bvt-play-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = btn.closest('.bvt-card');
        var video = card.querySelector('.bvt-video');
        if (!video) return;

        var play = btn.querySelector('.bvt-icon-play');
        var pause = btn.querySelector('.bvt-icon-pause');

        if (video.paused) {
          pauseAll(document);
          video.play();
          card.classList.add('bvt-playing');
          if (play) play.style.display = 'none';
          if (pause) pause.style.display = '';
        } else {
          resetCard(card);
        }
      });
    });

    document.querySelectorAll('.bvt-video').forEach(function (video) {
      video.addEventListener('ended', function () {
        resetCard(video.closest('.bvt-card'));
      });
    });
  }

  function init() {
    if (typeof Swiper === 'undefined') {
      setTimeout(init, 80);
      return;
    }
    document.querySelectorAll('.bvt-section').forEach(initSection);
    initPlayButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
